import ASSETS_NAMES from '../config/assetNames';

const renderAssetName = (param) => {
  if (param && typeof param === 'object') {
    if (param.title) {
      return param.title;
    }
    param = param.name;
  }
  return ASSETS_NAMES[param] || (param && param.toUpperCase()) || '';
};

export { renderAssetName };
